import React from "react";

export const FeatureFlags = React.createContext({});

export const FeatureFlagsProvider = ({ children }) => {
    const defaultFeatures = {
        isResearcherCreateMissionEnabled: true,
        isResearcherViewMissionEnabled: true,
        isResearcherSurveyEditingEnabled: true,
        isResearcherPricingEnabled: true,
        isResearcherMissionEditingAfterLaunchEnabled: false,
    }
    // const [features, setFeatures] = React.useState({});
    const [features, setFeatures] = React.useState(defaultFeatures);

    return (
        <FeatureFlags.Provider value={{ features }}>
            {children}
        </FeatureFlags.Provider>
    );
};